import React from "react"
import { useDispatch } from "react-redux"
import Link from "next/link"

import { toggleValuationModal } from "@/slices/valuationModalSlice"

import { Card, Col, Button } from "react-bootstrap"

function InterestedCard(props) {
    const dispatch = useDispatch()

    return (
        <Col as={Card} xs={12} lg={5} className="p-0 mt-5">
            <Card.Body className="d-flex flex-column justify-content-center">
                <Card.Title>
                    <h2 className="text-center">{props.title}</h2>
                </Card.Title>
                <Card.Text className="text-center">
                    {props.buttonTitle === "Search properties" ? (
                        <Link
                            href={{
                                pathname: "/properties/",
                                query: {
                                    page: 1,
                                    layout: "list",
                                    ordering: "-price",
                                    trans_type_id: props.transTypeId,
                                },
                            }}
                            passHref
                        >
                            <Button
                                size="lg"
                                variant="warning"
                                className="px-4 rounded-0"
                            >
                                <span className="text-bold m-0 text-white">
                                    {props.buttonTitle}
                                </span>
                            </Button>
                        </Link>
                    ) : (
                        <Button
                            size="lg"
                            variant="warning"
                            onClick={() => {
                                dispatch(toggleValuationModal(true))
                            }}
                            className="px-4 rounded-0"
                        >
                            <span className="text-bold m-0 text-white">
                                {props.buttonTitle}
                            </span>
                        </Button>
                    )}
                </Card.Text>
            </Card.Body>
        </Col>
    )
}

export default InterestedCard
